import React from 'react';
import { withConfig, Theme } from '../../config';
import { useLanguage } from '../../languages/languageContext';
import { createStyles, WithStyles, withStyles } from '@material-ui/styles';

const styles = createStyles({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  commentsButtonWrapper: {
    flexDirection: 'row',
    width: 150,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  commentButton: {
    flexDirection: 'row',
    fontSize: 14,
  },
  replyButtonWrapper: {
    flexDirection: 'row',
  },
  rightReplyButton: {
    boxSizing: 'border-box',
    padding: 10,
    paddingRight: 15,
    paddingLeft: 15,
    borderRadius: 50,
    height: 38,
    borderLeftWidth: 0,
    transition: '200ms',
    '&:hover': {
      transform: 'scale(1.1)',
      transition: '200ms',
    },
  },
});

interface Props extends WithStyles<typeof styles> {
  theme: Theme;
  replyHandler: () => void;
}

const CommentsReplyButton: React.FC<Props > = ({ theme, replyHandler, classes }) => {
  const { post } = useLanguage();
  return (
    <div className={classes.container}>
      <div className={classes.replyButtonWrapper}>
        <button onClick={replyHandler}>
          <div
            style={{
              backgroundColor: theme.BACKGROUND_PRIMARY,
              justifyContent: 'center',
              alignItems: 'center',
            }}
            className={classes.rightReplyButton}
          >
            <p style={{ color: theme.BUTTON_PRIMARY, display: 'block', fontSize: '15px', lineHeight: '20px' }}>
              {post.replyToComment}
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default withStyles(styles)(withConfig(CommentsReplyButton));
